var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"mt-2"},_vm._l((_vm.activationsByTiming),function(pair){return _c('li',{key:pair[0].startdate + pair[0].stopdate},[_c('span',{staticClass:"mr-1"},[_vm._v("\n        "+_vm._s(_vm._f("dayjs")(pair[0].startdate,'DD.MM.YYYY'))+" -\n        "+_vm._s(_vm._f("dayjs")(_vm.subtractOneDayFromDate(pair[0].stopdate),'DD.MM.YYYY'))+"\n      ")]),_vm._v(" "),_c('span',[_vm._v("("+_vm._s(_vm.$t('in'))+" "+_vm._s(pair[1].length)+" "+_vm._s(_vm.$t('stores'))+")")])])}))}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CampaignActivationTimingsList.vue?vue&type=template&id=76bcd5c3&
// module id = 1948
// module chunks = 5